import { Box, Typography } from "@mui/material";
import ReactLoading from "react-loading";
import { FC } from "react";
import { MainContainer } from "../../theme/material/customizations/components";

const Loading: FC<{ text?: string }> = ({ text }) => {
  return (
    <MainContainer
      sx={{
        position: "relative",
        pl: ".25vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {text && (
        <Box
          sx={{
            position: "absolute",
            top: "29.5vh",
            backgroundColor: "#333333aa",
            px: "1%",
            py: ".5%",
            borderRadius: ".5%",
            zIndex: 1,
            textAlign: "center",
          }}
        >
          <Typography variant="h5" fontFamily="monospace" color="#ccc">
            {text.toUpperCase()}
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          transform: {
            xs: "translate(0vw, .5vh)",
            md: "translate(0vw, .75vh)",
            lg: "translate(0vw, .95vh)",
            xl: "translate(0vw, 1.15vh)",
          },
        }}
      >
        <ReactLoading
          type="spin"
          color="#fff"
          height="100%"
          width="9.25vw"
        />
      </Box>
    </MainContainer >
  );
};

export default Loading;
